import _implicitStylesheets from "./share.css";
import _implicitScopedStylesheets from "./share.scoped.css?scoped=true";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="share-title${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<a${"a0:href"} target="_blank" rel="noopener noreferrer"${3}>Share to LinkedIn</a>`;
const $fragment3 = parseFragment`<a${"a0:href"} target="_blank" rel="noopener noreferrer"${3}>Share to X</a>`;
const $fragment4 = parseFragment`<a${"a0:href"} target="_blank" rel="noopener noreferrer"${3}>Share to Facebook</a>`;
const $fragment5 = parseFragment`<div class="axwp-share__destination axwp-share__destination-clipboard${0}"${2}><a${"a1:data-url"} href="#" rel="noopener noreferrer"${3}>Copy to clipboard</a><div class="axwp-share__tooltip${0}"${2}><span class="axwp-share__tooltip--message${0}"${2}>${"t5"}</span></div></div>`;
const stc0 = {
  classMap: {
    "axwp-share": true
  },
  key: 3
};
const stc1 = {
  classMap: {
    "axwp-share__destination": true,
    "axwp-share__destination-linkedin": true
  },
  key: 4
};
const stc2 = {
  classMap: {
    "axwp-share__destination": true,
    "axwp-share__destination-twitter": true
  },
  key: 8
};
const stc3 = {
  classMap: {
    "axwp-share__destination": true,
    "axwp-share__destination-facebook": true
  },
  key: 12
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [$cmp.hasUrl ? api_element("div", {
    className: api_normalize_class_name($cmp.wrapperClasses),
    key: 0
  }, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.title))]), api_element("div", stc0, [api_element("div", stc1, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "href": $cmp.linkedinUrl,
      "label": "Share to LinkedIn",
      "name": "Share to LinkedIn"
    },
    key: 5
  }, [api_static_fragment($fragment2, 7, [api_static_part(0, {
    attrs: {
      "href": $cmp.linkedinUrl
    }
  }, null)])])]), api_element("div", stc2, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "href": $cmp.twitterUrl,
      "label": "Share to X",
      "name": "Share to X"
    },
    key: 9
  }, [api_static_fragment($fragment3, 11, [api_static_part(0, {
    attrs: {
      "href": $cmp.twitterUrl
    }
  }, null)])])]), api_element("div", stc3, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "href": $cmp.facebookUrl,
      "label": "Share to Facebook",
      "name": "Share to Facebook"
    },
    key: 13
  }, [api_static_fragment($fragment4, 15, [api_static_part(0, {
    attrs: {
      "href": $cmp.facebookUrl
    }
  }, null)])])]), api_static_fragment($fragment5, 17, [api_static_part(1, {
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.copyToClipboard))
    },
    attrs: {
      "data-url": $cmp.url
    }
  }, null), api_static_part(5, null, api_dynamic_text($cmp.copyTooltipText))])])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3msmd4af8ag";
tmpl.legacyStylesheetToken = "undefined-_share";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
